import React from "react";
import { Image } from "@mantine/core";
import styles from "./StaffFace.module.css";

/**
 * Inside a round initials avatar: the staff photo when there is one (fills
 * the circle), else the initials.
 */
export const StaffFace: React.FC<{
  photo?: string | null;
  initials: string;
}> = ({ photo, initials }) =>
  photo ? (
    <Image src={photo} alt="" radius="50%" className={styles.photo} />
  ) : (
    <>{initials}</>
  );

/** An employee row's photo (same fields as the desktop staff headers). */
export const staffPhotoOf = (e: {
  staff_photo_url?: string | null;
  avatar_url?: string | null;
}): string | null => e.staff_photo_url ?? e.avatar_url ?? null;
